
    import * as React from 'react';

    const Exit16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M8 7.492L13.492 2l.508.508L8.508 8 14 13.49l-.508.508L8 8.508 2.508 14 2 13.492 7.492 8 2 2.508 2.508 2 8 7.492z" /></svg>
        </div>
      );
    };

    Exit16.displayName = 'Exit16';

    export default Exit16;
  